module.exports = __webpack_public_path__ + "img/zebre-parma-logo-icon.303fe4e5.png";